import type { JobDto } from "@shelflist/shared";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

const VARIANTS = {
  queued: "outline",
  running: "default",
  succeeded: "secondary",
  failed: "destructive",
  cancelled: "outline",
} as const;

export function JobStatusBadge({ job }: { job: Pick<JobDto, "status" | "cancelRequested"> }) {
  const { t } = useTranslation("jobs");
  return (
    <Badge variant={VARIANTS[job.status]}>
      {job.status === "running" && job.cancelRequested
        ? t("cancelRequested")
        : t(`status.${job.status}`)}
    </Badge>
  );
}
